import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { HelmetProvider } from 'react-helmet-async';
import ReactGA from 'react-ga4';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';
import { trpc, trpcClient } from './lib/trpc';
import { initSentry } from './lib/sentry';
import { initPerformanceMonitoring } from './lib/monitoring';
import App from './App';
import './index.css';
import './styles/animations.css';

// Initialize Sentry FIRST (before any other code runs)
initSentry();

// Initialize performance monitoring
initPerformanceMonitoring();

// Initialize Google Analytics
const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID || 'G-XXXXXXXXXX';
ReactGA.initialize(GA_MEASUREMENT_ID);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000, // 1 minute
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <trpc.Provider client={trpcClient} queryClient={queryClient}>
        <QueryClientProvider client={queryClient}>
          <App />
          <Analytics />
          <SpeedInsights />
        </QueryClientProvider>
      </trpc.Provider>
    </HelmetProvider>
  </React.StrictMode>
);
